module.exports = __webpack_public_path__ + "static/media/SingleLegStanceFemale.8f2a3685.svg";